import { sum } from 'lib/array/arrayUtils'
import { getJourneyV2IdKey, isJourneyV2 } from 'lib/flights/flightUtils'
import { floatify } from 'lib/maths/mathUtils'

const TAX_FEE_KEYS = ['flightBookingFee', 'flightServiceFee', 'flightCreditFee', 'flightAtolFee'] as const

function getJourneyPriceAll(
  item: App.Checkout.FlightItem,
  flight: App.Checkout.FlightItemFlight,
  journeysById: App.State['flights']['journeysById'],
) {
  const searchId = item.searchId
  if (!searchId) return undefined
  const journey = journeysById[getJourneyV2IdKey(flight.journeyId, searchId, flight.fareFamily?.id)]
  return isJourneyV2(journey) ? journey.price?.all : undefined
}

export function getFlightFareBreakdown(
  item: App.Checkout.FlightItem,
  journeysById: App.State['flights']['journeysById'],
): App.Checkout.FlightFareBreakdown {
  const fare = floatify(sum(item.flights, (flight) => {
    const price = getJourneyPriceAll(item, flight, journeysById)
    return (price?.totalFare ?? 0) - (price?.totalTax ?? 0)
  }))
  const addOns = item.otherFees?.flightSelectedSeatsTotal ?? 0
  const journeyTax = sum(item.flights, (flight) => getJourneyPriceAll(item, flight, journeysById)?.totalTax ?? 0)
  const otherTaxFees = sum([...TAX_FEE_KEYS], (key) => item.otherFees?.[key] ?? 0)
  const taxesAndFees = floatify(journeyTax + otherTaxFees)
  const baggage = floatify(
    (item.otherFees?.flightBaggageTotal ?? 0) + (item.otherFees?.flightBaggageAddonTotal ?? 0),
  )
  const total = floatify(fare + addOns + taxesAndFees + baggage)

  return {
    fare,
    addOns,
    taxesAndFees,
    baggage,
    total,
  }
}
